export const footerStyles = {
  footer: {
    dark: "bg-black bg-gradient-to-l from-gray-950",
    light: "bg-white",
    common: "z-30 pt-1 relative transition-opacity filter duration-700",
    outOfView: "opacity-0 brightness-0 saturate-0",
  },
  container: { common: "mx-auto max-w-[94%] px-4 py-6 lg:py-8" },
  hr: {
    dark: "border-gray-800",
    light: "border-gray-200",
    common: "my-5  sm:mx-auto lg:my-8",
  },
};
